'use client';

import React, { createContext, useState, useContext, ReactNode, useMemo } from 'react';

// Define the shape of the context data
interface HeaderContextType {
    isHeaderVisible: boolean;
    setIsHeaderVisible: (isVisible: boolean) => void;
}

// Create the context with a default value
const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

// Create a provider component that will wrap your app
export const HeaderProvider = ({ children }: { children: ReactNode }) => {
    const [isHeaderVisible, setIsHeaderVisible] = useState<boolean>(true); // Default to visible

    const value = useMemo(() => ({
        isHeaderVisible,
        setIsHeaderVisible
    }), [isHeaderVisible]);

    return (
        <HeaderContext.Provider value={value}>
            {children}
        </HeaderContext.Provider>
    );
};

// Create a custom hook for easy access to the context
export const useHeader = (): HeaderContextType => {
    const context = useContext(HeaderContext);
    if (context === undefined) {
        throw new Error('useHeader must be used within a HeaderProvider');
    }
    return context;
};